import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from './../../environments/environment';

@Injectable()
export class HttpService {
  constructor(public http: HttpClient) { }

  public getHeaderWithoutToken() {
    return new HttpHeaders()
      .append('Content-Type', 'application/json')
      .append('Accept', 'application/json');
  }

  public getHeader(tokenPrefix = '', token?) {
    let headers = this.getHeaderWithoutToken();
    headers = headers.append('Authorization', `${tokenPrefix }${token }`);
    return { headers };
  }


  public doGet(url, header = this.getHeader()) {
    return this.http.get(url, header).toPromise();
  }

  public doPost(url, json, header = this.getHeader()) {
    return this.http.post(url, json, header).toPromise();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/http.service.ts